module.exports = __webpack_public_path__ + "img/dy02.c70ebbfa.png";